<template>
  <div class="coupon-tag">
    <slot>
<!--      <span class="tag tag-red">待领取</span>-->
<!--      <span class="tag tag-red is-plain">待使用</span>-->
<!--      <span class="tag">已使用</span>-->
    </slot>
  </div>
</template>

<script>
export default {
  name: "couponFixedTag"
}
</script>

<style scoped lang="scss">
.coupon-tag{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: right;
  /deep/ .tag{
    display: inline-block;
    padding: 0 4px;
    height: 22px;
    line-height: 22px;
    border-radius: 0 0 6px 6px;
    font-size: 12px;
    color: #ccc;
    &:last-child{
      border-top-right-radius: 3px;
    }
    &-red{
      &:not(.is-plain){
        background-color: #ED1B12;
        color: white;
      }
      &.is-plain{
        background-color: rgba(237,27,18,0.1);
        color: #ED1B12;
      }
    }
    &-gary{
      &:not(.is-plain){
        background-color: #909399;
        color: white;
      }
      &.is-plain{
        background-color: #f4f4f5;
        color: #909399;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// common/couponPopover/couponFixedTag.vue